import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from './store/hooks';
import routes from './utils/routes';
import './App.css';

// Layout
import MainLayout from './components/layout/MainLayout';

// Pages
import Splash from './pages/Splash';
import Onboarding from './pages/Onboarding';
import Connect from './pages/auth/Connect';
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import CreatePassword from './pages/auth/CreatePassword';
import OTPVerification from './pages/auth/OTPVerification';
import UserDetails from './pages/auth/UserDetails';
import { Home, Notification, WatchList } from './pages/home';
import Market from './pages/market/Market';
import { Buckets, BucketDetail } from './pages/buckets';
import { CompanyDetail } from './pages/company';
import Portfolio from './pages/portfolio/Portfolio';
import {
  Profile,
  PersonalDetails,
  PushNotification,
  SelectLanguage,
  HelpCenter,
  FAQScreen,
  PrivacyPolicies,
  TermsAndCondition,
  AboutApp,
} from './pages/profile';
import Wallet from './pages/wallet/Wallet';
import { ExpertSearch, ExpertProfile, ExpertBooking, BookingConfirmation, ChatScreen, CallScreen, RateExpert, AllBookings } from './pages/expert';
import { Copilot } from './pages/copilot';

function App() {
  const colors = useAppSelector((state) => state.theme.theme);
  const isDark = useAppSelector((state) => state.theme.isDark);

  useEffect(() => {
    // Apply theme class to document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.backgroundColor, color: colors.textColor }}>
      <Routes>
        {/* Public routes */}
        <Route path={routes.splash} element={<Splash />} />
        <Route path={routes.onboarding} element={<Onboarding />} />
        <Route path={routes.connect} element={<Connect />} />
        <Route path={routes.login} element={<Login />} />
        <Route path={routes.signUp} element={<SignUp />} />
        <Route path={routes.createPassword} element={<CreatePassword />} />
        <Route path={routes.otpVerification} element={<OTPVerification />} />
        <Route path={routes.userDetails} element={<UserDetails />} />

        {/* Main app routes with bottom navigation */}
        <Route element={<MainLayout />}>
          <Route path={routes.home} element={<Home />} />
          <Route path={routes.market} element={<Market />} />
          <Route path={routes.buckets} element={<Buckets />} />
          <Route path={routes.bucketDetail} element={<BucketDetail />} />
          <Route path={routes.portfolio} element={<Portfolio />} />
          <Route path={routes.profile} element={<Profile />} />
          <Route path={routes.wallet} element={<Wallet />} />
          <Route path={routes.copilot} element={<Copilot />} />
          <Route path={routes.companyDetail} element={<CompanyDetail />} />
          <Route path={routes.expertSearch} element={<ExpertSearch />} />
          <Route path={routes.expertProfile} element={<ExpertProfile />} />
          <Route path={routes.expertBooking} element={<ExpertBooking />} />
          <Route path={routes.expertBookingConfirmation} element={<BookingConfirmation />} />
          <Route path={routes.chatScreen} element={<ChatScreen />} />
          <Route path={routes.callScreen} element={<CallScreen />} />
          <Route path={routes.rateExpert} element={<RateExpert />} />
          <Route path={routes.allBookings} element={<AllBookings />} />
          <Route path={routes.notification} element={<Notification />} />
          <Route path={routes.watchListHomeCard} element={<WatchList />} />
          {/* Profile sub-pages */}
          <Route path={routes.personalDetails} element={<PersonalDetails />} />
          <Route path={routes.pushNotification} element={<PushNotification />} />
          <Route path={routes.selectLanguage} element={<SelectLanguage />} />
          <Route path={routes.helpCenter} element={<HelpCenter />} />
          <Route path={routes.faqScreen} element={<FAQScreen />} />
          <Route path={routes.privacyPolicies} element={<PrivacyPolicies />} />
          <Route path={routes.termsAndCondition} element={<TermsAndCondition />} />
          <Route path={routes.aboutApp} element={<AboutApp />} />
        </Route>

        {/* Fallback route */}
        <Route path="*" element={<Navigate to={routes.splash} replace />} />
      </Routes>
    </div>
  );
}

export default App;
